<headline-text [headline]="'APPOI.APPOINTMENT_NOT_FOUND.HEADLINE' | translate"
               [text]="'APPOI.APPOINTMENT_NOT_FOUND.DESCRIPTION' | translate"
></headline-text>
